import React from 'react'
import { observer } from 'mobx-react'
import cn from 'classnames'
import LanguageSelector from '@ui/LanguageSelector'
import useStores from '@stores/useStores'
import ModuleHeader from '@ui/ModuleHeader'
import useResponsive from '@hooks/useResponsive'
import Actions from './Actions'
import StepMode from './Steps/StepMode'
import './styles.scss'

const SurveyMain = ({ showLanguageSelector }) => {
  const { surveyState } = useStores()
  const { currentQuestion } = surveyState
  const isResponsive = useResponsive(901)
  let timeout

  const handleSkip = () => {
    surveyState.currentQuestion.saveAnswer('')
    handleNext()
  }

  const handleNext = async () => {
    const { codename } = currentQuestion
    surveyState.continue()
    window.scroll({ top: 0, left: 0 })
    clearTimeout(timeout)

    if (surveyState.isCompleted && codename) {
      await surveyState.saveAnswers(codename)
    } else {
      timeout = setTimeout(() => surveyState.saveAnswers(codename), 1000)
    }
  }

  const handleBack = () => surveyState.previousQuestion()

  const onSkip = currentQuestion.isRequired ? null : handleSkip

  const onBack = surveyState.previousStepIndex >= 0 ? handleBack : null

  const onFinish = () => surveyState.submitSurvey()

  const showActions = !surveyState.isLastStep && !surveyState.isFirstStep

  return (
    <div
      className={cn('survey-component', {
        'main-last': surveyState.isLastStep,
        'main-first': surveyState.isFirstStep
      })}
    >
      <div className={cn('main-top-nav', { hide: !showActions })}>
        <div dir='ltr'>
          {!surveyState.isFirstStep && (
            <ModuleHeader
              title={currentQuestion.moduleTitle}
              subtitle={currentQuestion.moduleDescription}
              collapsible={isResponsive}
            />
          )}
          {showLanguageSelector && (
            <div className='hide-responsive'>
              <LanguageSelector sm />
            </div>
          )}
        </div>
      </div>
      <div className={cn('survey-question', { first: surveyState.isFirstStep })}>
        <StepMode onFinish={onFinish} onBack={onBack} onNext={handleNext} />
      </div>
      {showActions && (
        <div
          className={cn('actions-container', { 'hide-responsive': !showActions })}
        >
          <Actions onBack={onBack} onSkip={onSkip} onNext={handleNext} />
        </div>
      )}
    </div>
  )
}

export default observer(SurveyMain)
